function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useLayoutEffect, useState } from "react";
import useUploadyContext from "../hooks/useUploadyContext";
const createRequestUpdateHoc = ({
  eventType,
  getIsValidEventData,
  getRequestData
}) => Component => props => {
  const context = useUploadyContext();
  const [updater, setUpdater] = useState({
    updateRequest: null,
    requestData: null
  });
  const {
    id
  } = props;
  useLayoutEffect(() => {
    const handleEvent = (...params) => getIsValidEventData(id, ...params) === true ? new Promise(resolve => {
      setUpdater({
        updateRequest: data => {
          context.off(eventType, handleEvent);
          resolve(data);
        },
        requestData: getRequestData(...params)
      });
    }) : undefined;
    if (id) {
      context.on(eventType, handleEvent);
    }
    return () => {
      if (id) {
        context.off(eventType, handleEvent);
      }
    };
  }, [context, id]);
  return /*#__PURE__*/React.createElement(Component, _extends({}, props, updater));
};
export { createRequestUpdateHoc };